module.exports = require('salvus-shared/lib/i18n');
